var top_header_banner_slides = [];
function AddSlideToTopHeaderBanner(id, message){
    debug.func(console_pre + arguments.callee.name, console_colors);
    var slide_info = {
        "id" : id,
        "message" : message
    }

    var slide_type_exists = false;
    var index_of_found_slide = 0;
    $.each(top_header_banner_slides, function( i ) {
        if(id == top_header_banner_slides[i].id){
            slide_type_exists = true;
            index_of_found_slide = i;
            top_header_banner_slides[i]["message"] = message;
        }
    });

    if(slide_type_exists){
        $(".custom-top-header-banner").find(".slider-wrapper[rel="+index_of_found_slide+"]").text(message);
    }else{
        $(".custom-top-header-banner").append('<div class="page-width slider-wrapper" rel="'+index_of_found_slide+'">'+message+'</div>');
        top_header_banner_slides.push(slide_info);
    }

    if(top_header_banner_slides.length != 0){
        $(".custom-top-header-banner").slideDown();
    }

    
    
}